/*
 * Takes any array of objects and sort them. You just need to provide depth in form of an array
 * Usage:
 *    import { sortAlphanumericArray } from './sort-alphanumeric-array';
 *
 * Example:
 *  sortAlphanumericArray([2, 'b', 'a'], []) => [2, 'a', 'b']
 *  sortAlphanumericArray([{name: 2, {name: 'b', {name: 'a'}], ['name']) => [{name: 2}, {name: 'a'}, {name: 'b'}]
*/

import { isNumeric } from 'rxjs/internal-compatibility';

export function sortAlphanumericArray(arr: Array<any>, depth: Array<string>): Array<any> {
    return arr.sort((a, b) => {
        let valueA = a;
        let valueB = b;

        depth.forEach(val => {
            valueA = valueA[val];
            valueB = valueB[val];
            if (typeof(valueA) === 'undefined') {
                throw new Error(`cannot find object with depth "${val}"`);
            }
        });

        const nameA = isNumeric(valueA) ? valueA.toLocaleString() : valueA.toLowerCase();
        const nameB = isNumeric(valueB) ? valueB.toLocaleString() : valueB.toLowerCase();

        if (nameA < nameB) {
            return -1; // sort string ascending
        }

        if (nameA > nameB) {
            return 1;
        }

        return 0;
    });
}
